// src/components/DrinksMenuComponent.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

import {
    IconGlass,
    IconReceipt,
    IconChartBar,
    IconTicket,
    IconPrinter,
} from '@tabler/icons-react';

import './MenuComponent.css';


/* =========================================
   TYPES
   ========================================= */

interface DrinksMenuItem {
    id: number;
    titleEn: string;
    titleDa: string;
    icon: React.ReactNode;
    link: string;
}

interface DrinksMenuProps {
    eventID?: number;
    itemsToShow?: number[];
}


/* =========================================
   MENU ITEMS
   ========================================= */

const defaultDrinksMenuItems: DrinksMenuItem[] = [
    {
        id: 1,
        titleEn: 'Drinks Allowance',
        titleDa: 'Tildelt drinks',
        icon: <IconGlass />,
        link: '/admin/drinks/allowance',
    },
    {
        id: 4,
        titleEn: 'Create Collections',
        titleDa: 'Opret Collections',
        icon: <IconTicket />,
        link: '/admin/drink-ticket-collections',
    },
    {
        id: 5,
        titleEn: 'Collections Print',
        titleDa: 'Collections print',
        icon: <IconPrinter />,
        link: '/admin/drink-ticket-print',
    },
    {
        id: 3,
        titleEn: 'Bar Overview',
        titleDa: 'Drinks Oversigt',
        icon: <IconChartBar />,
        link: '/admin/drinks/overview',
    },
    {
        id: 2,
        titleEn: 'Manage Bars and Invoices',
        titleDa: 'Administrér bar og faktura',
        icon: <IconReceipt />,
        link: '/admin/event-bars',
    },
];


/* =========================================
   COMPONENT
   ========================================= */

const DrinksMenuComponent: React.FC<DrinksMenuProps> = ({
    eventID,
    itemsToShow,
}) => {

    const { language } = useLanguage();

    const filteredMenuItems = itemsToShow
        ? defaultDrinksMenuItems.filter((item) =>
            itemsToShow.includes(item.id)
        )
        : defaultDrinksMenuItems;


    return (
        <div className="menu-container">

            <section className="menu-section">

                {/* HEADER */}

                <div className="menu-section-header">

                    <h2 className="menu-section-title">
                        {language === 'da'
                            ? 'Drinks administration'
                            : 'Drinks Administration'}
                    </h2>

                    <span className="menu-section-count">
                        {filteredMenuItems.length}
                    </span>

                </div>


                {/* MENU */}

                <div className="menu-grid">

                    {filteredMenuItems.map((item) => {

                        const title =
                            language === 'da'
                                ? item.titleDa
                                : item.titleEn;

                        const link = eventID
                            ? `${item.link}/${eventID}`
                            : item.link;


                        return (
                            <Link
                                key={item.id}
                                to={link}
                                className="menu-card"
                            >

                                <div className="menu-card-content">

                                    <div className="menu-icon">
                                        {item.icon}
                                    </div>

                                    <div className="menu-card-text">

                                        <div className="menu-title">
                                            {title}
                                        </div>

                                    </div>

                                </div>

                            </Link>
                        );
                    })}

                </div>

            </section>

        </div>
    );
};

export default DrinksMenuComponent;